// Synchronous helpers for reading auth state and per-user cache keys.
// Used by code paths that run BEFORE the AuthProvider mounts (e.g. Shell's
// useState initializer for activeFilter). Reads Supabase's persisted session
// from localStorage directly so we can namespace the preference cache by user.

export function getCachedUserId(): string | null {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('sb-') && key.endsWith('-auth-token')) {
        const raw = localStorage.getItem(key)
        if (!raw) continue
        const session = JSON.parse(raw)
        const userId = session?.user?.id ?? session?.currentSession?.user?.id
        if (typeof userId === 'string' && userId.length > 0) return userId
      }
    }
  } catch {}
  return null
}

export function preferencesCacheKey(userId: string): string {
  return `slash-prefs:${userId}`
}

export function readPreferencesCache(userId: string): unknown | null {
  try {
    const raw = localStorage.getItem(preferencesCacheKey(userId))
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function writePreferencesCache(userId: string, prefs: unknown): void {
  try {
    localStorage.setItem(preferencesCacheKey(userId), JSON.stringify(prefs))
  } catch {}
}

export function clearPreferencesCache(userId: string): void {
  try { localStorage.removeItem(preferencesCacheKey(userId)) } catch {}
}
